__turbopack_context__.v({
  "card": "order-card-module__yP-dWa__card",
  "field": "order-card-module__yP-dWa__field",
  "submit": "order-card-module__yP-dWa__submit",
});
